import React, { useContext } from 'react';
import Grid from 'components/Grid';
import PostFormContext from '../PostFormContext';

const PostFormWrapper = args => useContext(PostFormContext).asDialog
  ? <React.Fragment {...args} />
  : <Grid container spacing={2} direction="column" wrap="nowrap" {...args} />;

export default PostFormWrapper;
